/* eslint-disable max-len */
import React, {useState, useEffect} from 'react'
import { PriceHandler } from '../../../redux/helper/CamelCase'

const StatisticsAndMIS = (props) => {
    const {DISTRIBUTOR, currentYear, setCurrentYear, handleOrderData, orderData} =props
    const [openDrop, setOpenDrop] = useState(false)
    const [yearDropDown, setYearDropDown] = useState([])
    
    function getCurrentFinancialYear() {
        const years = []
        var today = new Date();
        let fiscalyear = "";
        let fiscalyearKey = "";
        if ((today.getMonth() + 1) > 3) {
            fiscalyear = "April " +(today.getFullYear()) + " - " + "March "+ Number(Number(today.getFullYear())+1)
            fiscalyearKey = '04-'+(today.getFullYear())+","+ "03-"+ Number(Number(today.getFullYear())+1)
            years.push({[fiscalyearKey]:fiscalyear})
        }
        for (let index = 0; index <= 9; index++) {
            fiscalyear = "April " + (today.getFullYear() - index-1) + " - " + "March "+ (today.getFullYear() - index)
            fiscalyearKey = '04-'+(today.getFullYear() - index-1)+","+ "03-"+ (today.getFullYear() - index)
            years.push({[fiscalyearKey]:fiscalyear})
        }
        setYearDropDown(years)
        handleOrderData(Object.keys(years[0])[0],'')
        setCurrentYear(years[0])
    }

    useEffect(() => {
        getCurrentFinancialYear()
    }, []);

    return (
        <div className=" lg:w-[50%] w-full bg-[#F5F5FA] pt-[27px] pb-5 sm:px-4 lg:px-5 px-3 rounded-lg">
            <div className="flex justify-between flex-wrap  items-center rounded-lg">
                <p className="text-black underline text-sm55 hover:text-[#ED1C24] mb-4 font-semibold">
                    <a href={DISTRIBUTOR.MIS_LINK} target='_blank' rel="noreferrer">
                        My Statistics & MIS
                    </a>
                </p>
                <div>
                    <div className="bg-white flex items-center rounded-lg py-1 w-fit px-1 mb-4">
                        <span className="text-sm47 font-semibold text-[#090406] cursor-pointer dropdown-sort">Financial Year</span>
                        <div className="dropdown relative ml-2" onClick={() => setOpenDrop(!openDrop)}>
                            <button type="button" id="dropdownDefaultButton" data-dropdown-toggle="dropdown123"  aria-expanded="false" className="dropdown-sort flex bg-[#F5F5FA] p-1 rounded-lg items-center">
                                <p className="text-sm font-semibold  text-[#555259] px-1.5">{Object.values(currentYear).length> 0 && Object.values(currentYear)[0]}</p>
                                <img src="/images/dropdown-filled.svg" alt="icon"/>
                            </button>
                            <ul id="dropdown123" className={`dropdown-sort-content sm:w-[200px] h-[90px] overflow-y-auto scrollbar-menu w-[201px] absolute top-8 right-[-10px] bg-[#FFFFFF] rounded-[10px] shadow-s2 z-[9999]  pl-2 pr-1 py-3 ${!openDrop? 'hidden':''}`} aria-labelledby="special1">
                                {yearDropDown.length >0 && yearDropDown.slice(0, 2).map((item,index)=> (
                                    <li className="w-full bg-[#ffffff] pl-[5px]" key={`dropYear-${index}`} onClick={()=>{setCurrentYear(item); handleOrderData(Object.keys(item)[0],'')}}>
                                        <div className="w-full flex items-center">
                                            <div className="relative  flex items-center">            
                                                <label htmlFor="checkbox-92" className="sm:text-base text-sm font-normal text-[#555259] pl-1 cursor-pointer">{ Object.values(item)[0] }</label>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>  
            {/* <!--order values  --> */}
            <div className="grid lg:grid-cols-2 sm:grid-cols-2 grid-cols-1 lg:gap-7 md:gap-5 gap-4 pt-1">
                <div className="bg-[#FFFFFF] rounded-lg shadow-s7">
                    <div className="border-l-4 rounded-lg rounded-tl-lg rounded-tr-none border-[#ED1C24] pl-2 py-2.5">
                        <p className="sm:text-sm58 font-semibold text-[#090406]">Total Order</p>
                        <p className=" sm:text-sm58 font-normal text-black">Total Count : {orderData[1]?.total.COUNT}</p>
                        <p className="sm:text-sm58 font-normal text-black">Total Value : <span className="text-[#15090E]">{PriceHandler(orderData[1]?.total.SUM)}</span></p> 
                    </div>
                </div>
                <div className="bg-[#FFFFFF] rounded-lg shadow-s7">
                    <div className="border-l-4 rounded-lg rounded-tl-lg rounded-tr-none border-[#ED1C24] pl-2 py-2.5">
                        <p className="sm:text-sm58 font-semibold text-[#090406]">Pending Approval Orders</p>
                        <p className=" sm:text-sm58 font-normal text-black">Total Count : {orderData[1]?.pending.count}</p>
                        <p className="sm:text-sm58 font-normal text-black">Total Value : <span className="text-[#15090E]">{PriceHandler(orderData[1]?.pending.sum)}</span></p>  
                    </div>
                </div>
                <div className="bg-[#FFFFFF] rounded-lg shadow-s7">
                    <div className="border-l-4 rounded-lg rounded-tl-lg rounded-tr-none border-[#ED1C24] pl-2 py-2.5">
                        <p className="sm:text-sm58 font-semibold text-[#090406]">Trade Order</p>
                        <p className=" sm:text-sm58 font-normal text-black">Total Count :{orderData[1]?.trade.COUNT}</p>
                        <p className="sm:text-sm58 font-normal text-black">Total Value : <span className="text-[#15090E]">{PriceHandler(orderData[1]?.trade.SUM)}</span></p>  
                    </div>
                </div>
                <div className="bg-[#FFFFFF] rounded-lg shadow-s7">
                    <div className="border-l-4 rounded-lg rounded-tl-lg rounded-tr-none border-[#ED1C24] pl-2 py-2.5">
                        <p className="sm:text-sm58 font-semibold text-[#090406]">Orders Pending for Dispatch </p>
                        <p className=" sm:text-sm58 font-normal text-black">Total Count : {orderData[1]?.dispatch.COUNT}</p>
                        <p className="sm:text-sm58 font-normal text-black">Total Value : <span className="text-[#15090E]">{PriceHandler(orderData[1]?.dispatch.SUM)}</span></p> 
                    </div>
                </div>
                <div className="bg-[#FFFFFF] rounded-lg shadow-s7">
                    <div className="border-l-4 rounded-lg rounded-tl-lg rounded-tr-none border-[#ED1C24] pl-2 py-2.5">
                        <p className="sm:text-sm58 font-semibold text-[#090406]">Trade EUB Order</p>
                        <p className=" sm:text-sm58 font-normal text-black">Total Count : {orderData[1]?.trade_eub.COUNT}</p>
                        <p className="sm:text-sm58 font-normal text-black">Total Value : <span className="text-[#15090E]">{PriceHandler(orderData[1]?.trade_eub.SUM)}</span></p> 
                    </div>
                </div>
   
            </div>
        </div>
    )
}

export default StatisticsAndMIS
